import { encode } from 'js-base64';
import { type JsonValue } from 'type-fest';

export const encodeId = <T extends JsonValue>(obj: T) => encodeURIComponent(encode(JSON.stringify(obj)));
